/*eslint no-magic-numbers: ["error", { "ignore": [0] }]*/
import React, { useEffect, useState } from 'react'

import { getFiltersCountries } from 'api/filters'

export const CountriesContext = React.createContext({})

export const CountriesProvider = ({ children }) => {
  const [countriesOptions, setCountriesOptions] = useState([])

  const getCountriesOptions = () => {
    getFiltersCountries().then((data) => {
      const options = data.map((option) => {
        return {
          label: option.name,
          value: option.id,
          code: option.code,
          region: option.Region.name,
          regionId: option.Region.id
        }
      })
      setCountriesOptions([...options])
    })
  }


  useEffect(() => {
    getCountriesOptions()
  }, [])


  if (countriesOptions.length === 0) {
    return null
  }

  return (
    <CountriesContext.Provider value={{countriesOptions}}>
      {children}
    </CountriesContext.Provider>
  )
}

export default CountriesProvider
